<template>
    <div>
        <b-row>
            <b-col cols="12">
                <app-sub-title text="Criterios de Exportación" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="2">
                <app-form-select-input
                    :options="cities"
                    v-model="filters.city"
                    placeholder="Ciudad"
                />
            </b-col>
            <b-col cols="12" md="5">
                <app-autocomplete
                    :items="clients"
                    v-model="filters.client"
                    placeholder="Cliente"
                ></app-autocomplete>
            </b-col>
            <b-col cols="12" md="1">
                <app-form-select-input 
                    :options="years"
                    v-model="filters.year"
                    placeholder="Año"
                />
            </b-col>
            <b-col cols="12" md="2">
                <app-form-select-input 
                    :options="months"
                    v-model="filters.month"
                    placeholder="Mes"
                />
            </b-col>
            <b-col cols="12" md="2">
                <b-btn variant="primary" @click="exportData"><i class="fa fa-download" aria-hidden="true"></i></b-btn>
                <b-btn variant="secondary" @click="clearFilters"><i class="fa fa-times" aria-hidden="true"></i></b-btn>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Autocomplete from '../../../../UI/Controls/AutocompleteV2/Autocomplete';
import reportingRepository from '../../../../../repositories/reporting.repository';
export default {
    name: 'export_operational_indicators',
    components: {
        appAutocomplete: Autocomplete
    },
    data: () => ({
        filters: {
            city: '',
            client: '',
            year: '',
            month: '',
        }
    }),
    computed: {
        ...mapGetters(['cities', 'clients', 'years', 'months'])
    },
    methods: {
        exportData() {

            if(!!this.filters.year ^ !!this.filters.month) return toastr.error('Debe seleccionar año y mes');

            const objParams = {
                city: this.filters.city,
                client: !!this.filters.client? this.filters.client.id: '',
                year: this.filters.year,
                month: this.filters.month,
            }
            const params = [];
            Object.keys(objParams).map(key => (!!objParams[key] && params.push(`${key}=${objParams[key]}`)));
            const url = `exports/usage-indicators/export-excel?${params.join('&')}`;
            window.open(url, '_blank');
        },
        clearFilters() {
            Object.keys(this.filters).map(key => this.filters[key] = '');
        }
    },
    created() {
        this.load('cities');
        this.load('clients');
        this.load('years');
    }
}
</script>